"use strict";
var provider_1 = require('./provider');
function isProviderLiteral(obj) {
    return obj && typeof obj == 'object' && obj.provide;
}
exports.isProviderLiteral = isProviderLiteral;
function createProvider(obj) {
    return new provider_1.Provider(obj.provide, obj);
}
exports.createProvider = createProvider;
//# sourceMappingURL=provider_util.js.map


/*****************
 ** WEBPACK FOOTER
 ** /var/www/smartwifi/shared/~/@angular/core/src/di/provider_util.js
 ** module id = 61
 ** module chunks = 0 1 2
 **/